import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import ReturnReasonDropdown from '../../../../../components/return-reason-dropdown';
import { RowPropType } from '../../../../../prop-types/react-table';
import messages from '../messages';
import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { ItemReturnReasonCell, ItemReturnReasonColumnId } from './item-return-reason';

const EditableReturnReasonCell = ({ value, row, updateRowProperty }) => {
  const onChange = useCallback(
    (newValue) => {
      updateRowProperty(row.id, ItemReturnReasonColumnId, newValue);
    },
    [updateRowProperty, row.id],
  );

  return row.isSelected ? (
    <ReturnReasonDropdown dropdownMenuShouldHaveWidthOfButton fullWidth onChange={onChange} selectedReturnReasonId={value || ''} />
  ) : (
    <ItemReturnReasonCell value={value} />
  );
};

EditableReturnReasonCell.propTypes = {
  value: PropTypes.string,
  row: RowPropType.isRequired,
  updateRowProperty: PropTypes.func.isRequired,
};

const createItemEditableReturnReasonColumnDefinition = createColumnDefinitionBuilder({
  Header: <FormattedMessage {...messages.returnReason} />,
  accessor: ItemReturnReasonColumnId,
  Cell: EditableReturnReasonCell,
  width: 2,
});

export { createItemEditableReturnReasonColumnDefinition };
